export default __webpack_public_path__ + "static/media/cat12.0b26fdfe.png";